module.exports = __webpack_public_path__ + "static/img/scf.2155acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scf.jpg
// module id = JC9z
// module chunks = 0